import { FETCH_SERVICE_DETAILS } from "../../actions/actionTypes";

const initialState = {  
    serviceDetails: {},
    loading: false,
};

const reducer = (state = initialState, action) => {
    
    switch (action.type) {    
        case FETCH_SERVICE_DETAILS.REQUEST:
            return {...state,loading: true}
        case FETCH_SERVICE_DETAILS.FAILURE:
            return {...state, loading: false}
        case FETCH_SERVICE_DETAILS.SUCCESS:             
            return {...state, serviceDetails: action.obj.data, loading: false}    
        default:
            return state
    }
}

export default reducer;